import React from 'react';
import IconButton from '@/components/ui/custom/buttons/IconButton';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

interface ActivityViewContainerProps {
  stepper: React.ReactNode;
  close?(): void;
  previewer: React.ReactNode;
}

function ActivityViewContainer({
  close,
  previewer,
  stepper,
}: ActivityViewContainerProps) {
  return (
    <div className="flex flex-col gap-8">
      <div className="relative flex justify-between">
        {stepper}
        <ConditionalRenderer condition={!!close}>
          <IconButton
            className="absolute -right-2.5 -top-2.5"
            testId="closeButton"
            id="close-button"
            onClick={close}
            icon={<XMarkIcon className="text-secondary w-7" />}
          />
        </ConditionalRenderer>
      </div>
      {previewer}
    </div>
  );
}

export default ActivityViewContainer;
